'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _effects = require('redux-saga/effects');

var _roles = require('../actions/roles');

var _api = require('../api');

var _marked = /*#__PURE__*/regeneratorRuntime.mark(fetchRoles),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(fetchRole),
    _marked3 = /*#__PURE__*/regeneratorRuntime.mark(editRole),
    _marked4 = /*#__PURE__*/regeneratorRuntime.mark(createRole),
    _marked5 = /*#__PURE__*/regeneratorRuntime.mark(fetchRolesRequest),
    _marked6 = /*#__PURE__*/regeneratorRuntime.mark(fetchRoleRequest),
    _marked7 = /*#__PURE__*/regeneratorRuntime.mark(editRoleRequest),
    _marked8 = /*#__PURE__*/regeneratorRuntime.mark(createRoleRequest);

function fetchRoles() {
    var response;
    return regeneratorRuntime.wrap(function fetchRoles$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.prev = 0;
                    _context.next = 3;
                    return (0, _effects.call)(_api.request, 'get', '/roles');

                case 3:
                    response = _context.sent;
                    _context.next = 6;
                    return (0, _effects.put)(_roles.actionCreators.fetchRolesSucceeded(response.data));

                case 6:
                    _context.next = 12;
                    break;

                case 8:
                    _context.prev = 8;
                    _context.t0 = _context['catch'](0);
                    _context.next = 12;
                    return (0, _effects.put)(_roles.actionCreators.fetchRolesFailed());

                case 12:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this, [[0, 8]]);
}

function fetchRole(_ref) {
    var roleId = _ref.roleId;
    var response;
    return regeneratorRuntime.wrap(function fetchRole$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    _context2.prev = 0;
                    _context2.next = 3;
                    return (0, _effects.call)(_api.request, 'get', '/roles/' + roleId);

                case 3:
                    response = _context2.sent;
                    _context2.next = 6;
                    return (0, _effects.put)(_roles.actionCreators.fetchRoleSucceeded(response.data));

                case 6:
                    _context2.next = 12;
                    break;

                case 8:
                    _context2.prev = 8;
                    _context2.t0 = _context2['catch'](0);
                    _context2.next = 12;
                    return (0, _effects.put)(_roles.actionCreators.fetchRoleFailed());

                case 12:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _marked2, this, [[0, 8]]);
}

function editRole(_ref2) {
    var roleId = _ref2.roleId,
        changes = _ref2.changes,
        redirect = _ref2.redirect;
    return regeneratorRuntime.wrap(function editRole$(_context3) {
        while (1) {
            switch (_context3.prev = _context3.next) {
                case 0:
                    _context3.prev = 0;
                    _context3.next = 3;
                    return (0, _effects.call)(_api.request, 'put', '/roles/' + roleId, changes);

                case 3:
                    _context3.next = 5;
                    return (0, _effects.put)(_roles.actionCreators.editRoleSucceeded());

                case 5:
                    if (!redirect) {
                        _context3.next = 8;
                        break;
                    }

                    _context3.next = 8;
                    return (0, _effects.call)(redirect);

                case 8:
                    _context3.next = 14;
                    break;

                case 10:
                    _context3.prev = 10;
                    _context3.t0 = _context3['catch'](0);
                    _context3.next = 14;
                    return (0, _effects.put)(_roles.actionCreators.editRoleFailed());

                case 14:
                case 'end':
                    return _context3.stop();
            }
        }
    }, _marked3, this, [[0, 10]]);
}

function createRole(_ref3) {
    var role = _ref3.role,
        redirect = _ref3.redirect;
    return regeneratorRuntime.wrap(function createRole$(_context4) {
        while (1) {
            switch (_context4.prev = _context4.next) {
                case 0:
                    _context4.prev = 0;
                    _context4.next = 3;
                    return (0, _effects.call)(_api.request, 'post', '/roles/', role);

                case 3:

                    (0, _effects.put)(_roles.actionCreators.createRoleSucceeded());

                    if (!redirect) {
                        _context4.next = 7;
                        break;
                    }

                    _context4.next = 7;
                    return (0, _effects.call)(redirect);

                case 7:
                    _context4.next = 13;
                    break;

                case 9:
                    _context4.prev = 9;
                    _context4.t0 = _context4['catch'](0);
                    _context4.next = 13;
                    return (0, _effects.put)(_roles.actionCreators.createRoleFailed());

                case 13:
                case 'end':
                    return _context4.stop();
            }
        }
    }, _marked4, this, [[0, 9]]);
}

function fetchRolesRequest() {
    return regeneratorRuntime.wrap(function fetchRolesRequest$(_context5) {
        while (1) {
            switch (_context5.prev = _context5.next) {
                case 0:
                    _context5.next = 2;
                    return (0, _effects.takeLatest)(_roles.actionTypes.FETCH_ROLES_REQUEST, fetchRoles);

                case 2:
                case 'end':
                    return _context5.stop();
            }
        }
    }, _marked5, this);
}

function fetchRoleRequest() {
    return regeneratorRuntime.wrap(function fetchRoleRequest$(_context6) {
        while (1) {
            switch (_context6.prev = _context6.next) {
                case 0:
                    _context6.next = 2;
                    return (0, _effects.takeLatest)(_roles.actionTypes.FETCH_ROLE_REQUEST, fetchRole);

                case 2:
                case 'end':
                    return _context6.stop();
            }
        }
    }, _marked6, this);
}

function editRoleRequest() {
    return regeneratorRuntime.wrap(function editRoleRequest$(_context7) {
        while (1) {
            switch (_context7.prev = _context7.next) {
                case 0:
                    _context7.next = 2;
                    return (0, _effects.takeLatest)(_roles.actionTypes.EDIT_ROLE_REQUEST, editRole);

                case 2:
                case 'end':
                    return _context7.stop();
            }
        }
    }, _marked7, this);
}

function createRoleRequest() {
    return regeneratorRuntime.wrap(function createRoleRequest$(_context8) {
        while (1) {
            switch (_context8.prev = _context8.next) {
                case 0:
                    _context8.next = 2;
                    return (0, _effects.takeLatest)(_roles.actionTypes.CREATE_ROLE_REQUEST, createRole);

                case 2:
                case 'end':
                    return _context8.stop();
            }
        }
    }, _marked8, this);
}

exports.default = [fetchRolesRequest, fetchRoleRequest, editRoleRequest, createRoleRequest];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ./src/client/effects/roles.js
// module id = 2230
// module chunks = 0